// extracted by mini-css-extract-plugin
export default {"legal-disclaimer":"TotalReturnStatement_legal-disclaimer__7IyA6"};